import React from 'react';
import {
  ComponentType,
  ExtraStyleType,
  FieldCustom,
} from '../FieldCustom/FieldCustom';
import styles from './CheckboxFieldCustom.module.scss';

export default function CheckboxFieldCustom({
  disabled,
  extraStyle = {},
  label,
  name,
  required,
}: {
  disabled?: boolean;
  extraStyle?: ExtraStyleType;
  label: string;
  name: string;
  required?: boolean;
}): JSX.Element {
  const CustomizedCheckboxField = ({ form, field }: ComponentType) => {
    const { name, value } = field;
    const { setFieldValue } = form;

    return (
      <>
        <label className={styles.container}>
          <input
            type="checkbox"
            checked={value}
            onChange={() => setFieldValue(name, !value)}
          />
          <span className={styles.checkmark} />
        </label>
      </>
    );
  };

  return (
    <>
      <FieldCustom
        component={CustomizedCheckboxField}
        disabled={disabled}
        {...(extraStyle && { extraStyle: extraStyle })}
        label={label}
        name={name}
        required={required}
        type="checkbox"
      />
    </>
  );
}
